import { FormGroup } from "../../../components/forms";
import { NumberInput, RadioInput } from "../../../components/form-fields";
import { FC } from "react";
import { MAX_LOADING_PERCENTAGE } from "../../../constants";
import { IOption } from "../../../components/form-fields/RadioInput";

const LoadingOptions: IOption<"" | "percentage">[] = [
  { value: "", label: "No Loading" },
  { value: "percentage", label: "Percentage" },
];

type Props = {
  loading: { type: string; value: number };
  onTypeChange: (type: string) => void;
  onValueChange: (value: number) => void;
};

export const SgLoadings: FC<Props> = ({ loading, onTypeChange, onValueChange }) => {
  const maxValue = MAX_LOADING_PERCENTAGE;
  return (
    <>
      <FormGroup title="Loading Type">
        <RadioInput
          data-testid="loadingType"
          aria-label="loadingType"
          name="loadingType"
          options={LoadingOptions}
          value={loading.type}
          onValueChange={onTypeChange}
        />
      </FormGroup>
      {loading.type && (
        <FormGroup title="Loading Value">
          <NumberInput
            data-testid="loadingValue"
            aria-label="loadingValue"
            name="loadingValue"
            value={loading.value}
            min={1}
            max={maxValue}
            onValueChange={onValueChange}
          />
        </FormGroup>
      )}
    </>
  );
};

export default SgLoadings;
